export default "__VITE_ASSET__d520360d__"